/**
 * deeply copy object or arrays with nested attributes
 * @param  {any} obj
 * @return {any}     a depply copied replica of arguement passed
 */
var deepClone = function deepClone(obj) {
  if (!obj || typeof obj !== 'object') {
    return obj;
  }
  var newObj = {};
  if (Array.isArray(obj)) {
    newObj = obj.map(function (item) {
      return deepClone(item);
    });
  } else {
    Object.keys(obj).forEach(function (key) {
      return newObj[key] = deepClone(obj[key]);
    });
  }
  return newObj;
};
module.exports = deepClone;